import tw from 'tailwind-styled-components'
import {cn} from '@containers/html-utils'

export const TwTab = tw.div<{
  $active?: boolean
  $slim?: boolean
  $tight?: boolean
  $forcedState?: 'hover'
}>`
  tab
  group/tab
  cursor-pointer
  min-w-0
  h-40
  py-12
  flex-1
  flex
  items-center
  justify-center
  ${p =>
    cn(
      p.$active
        ? cn('text-primary', 'shadow-border-b-4', 'shadow-action-default')
        : cn('text-secondary'),
      p.$slim ? 'px-4' : 'px-12',
      p.$tight ? 'gap-4' : 'gap-8'
    )}
`

export const TwPanelTab = tw.div<{
  $active?: boolean
  $slim?: boolean // not used, remove later
  $tight?: boolean // note used, remove later
  $forcedState?: 'hover'
}>`
  tab
  tab--new-style
  group/tab
  cursor-pointer
  min-w-0
  h-40
  p-12
  rounded-8
  gap-8
  flex-1
  flex
  items-center
  justify-center
  text-panel-text-primary
  ${p => {
    const cx: string[] = []
    if (p.$active) {
      cx.push('bg-panel-background-active')
    } else if (p.$forcedState === 'hover') {
      cx.push('bg-panel-background-hover')
    } else {
      cx.push('hover:bg-panel-background-hover')
    }
    return cx.join(' ')
  }}
`

const dotMixin = cn(
  'after:content-[""]',
  'after:absolute',
  'after:top-[2px]',
  'after:-right-[6px]',
  'after:block',
  'after:rounded-full',
  'after:w-4',
  'after:h-4',
  'after:bg-placeholder'
)

export const TwTitleWrapper = tw.div<{$dot?: boolean}>`
  isolate
  relative
  min-w-0
  h-full
  ${p => cn(p.$dot && dotMixin)}
`

const fadeMixin = `
  [mask-image:linear-gradient(270deg,transparent_0%,black_34px)]
  [mask-composite:'destination-in']
`

export const TwTitle = tw.div<{$allowLongTitles?: boolean; $fade?: boolean}>`
  min-w-0
  h-full
  text-14
  leading-4
  whitespace-nowrap
  ${p => cn(!p.$allowLongTitles && 'overflow-hidden', p.$fade && fadeMixin)}
`

export const TwMenuTabTitle = tw(TwTitle)<{
  $active?: boolean
  $disabled: boolean
  $lineClamp?: 2 | 3
}>`
  text-primary
  ${p => {
    switch (p.$lineClamp) {
      case 2:
        return '!line-clamp-2 !whitespace-normal'
      case 3:
        return '!line-clamp-3 !whitespace-normal'
      default:
        return ''
    }
  }}
  ${p => (p.$disabled ? 'text-disabled' : 'hover:text-primary')}
`

export const TwMenuTab = tw.div<{$disabled?: boolean; $active?: boolean}>`
  relative
  flex
  items-center
  cursor-pointer
  px-12
  py-8
  rounded-8
  gap-4

  ${p => (p.$active ? 'bg-background-active' : 'hover:bg-background-hover')}
  ${p => (p.$disabled ? 'text-disabled' : '')}
`
